import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ProductoStats() {
  const temas = ['Familia', 'Emociones', 'Vida cotidiana', 'Salud', 'Gramática', 'Cultura Sorda', 'Situaciones reales'];
  const formatos = ['Digital', 'PDF', 'Celular', 'Tablet', 'PC', 'Imprimible', '100% argentino', 'Edición 2026'];
  return <section className="bg-lsa-dark py-10 px-5" data-id="element-234">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-md mx-auto bg-lsa-cyan text-lsa-deep rounded-3xl p-7 shadow-2xl shadow-lsa-cyan/20" data-id="element-235">
        {/* Badge */}
        <div className="flex justify-center mb-6" data-id="element-236">
          <span className="inline-flex items-center gap-2 bg-white/20 text-lsa-deep rounded-full px-4 py-1.5 text-[12px] font-bold uppercase tracking-wide" data-id="element-237">
            <Check size={15} strokeWidth={3} data-id="element-238" /> Sistema N°1 en Argentina
          </span>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 divide-x divide-lsa-deep/15 mb-7 text-center" data-id="element-239">
          <div className="px-2" data-id="element-240">
            <div className="text-[40px] font-extrabold leading-none" data-id="element-241">2000</div>
            <div className="text-[12px] font-bold uppercase tracking-wider mt-1 opacity-70" data-id="element-242">
              Señas
            </div>
          </div>
          <div className="px-2" data-id="element-243">
            <div className="text-[40px] font-extrabold leading-none" data-id="element-244">7</div>
            <div className="text-[12px] font-bold uppercase tracking-wider mt-1 opacity-70" data-id="element-245">
              Tomos
            </div>
          </div>
        </div>

        {/* Topics */}
        <p className="text-center font-bold text-[14px] leading-relaxed mb-6 px-1" data-id="element-246">
          {temas.map((tema, i) => <Fragment key={i} data-id="element-247">
              {tema}
              {i < temas.length - 1 && <span className="opacity-40 mx-1.5" data-id="element-248">·</span>}
            </Fragment>)}
        </p>

        {/* Format pills */}
        <div className="flex flex-wrap justify-center gap-2" data-id="element-249">
          {formatos.map((f, i) => <span key={i} className="bg-white/20 text-lsa-deep rounded-full px-3.5 py-1.5 text-[12px] font-semibold" data-id="element-250">
              {f}
            </span>)}
        </div>
      </motion.div>
    </section>;
}